<div class="toast col-lg-4 col-md-4 col-sm-8 fadeInRight animated">
  <div class="col-lg-12 col-md-12 col-sm-12 pr-0">
    <div class="alert alert-dismissible alert-{{toastModel.Type}}">
      <!-- <button type="button" class="close" data-dismiss="alert">×</button> -->
      <h5 class="mb-1">{{toastModel.Title}}</h5>
      {{toastModel.Message}}
      <a [href]="toastModel.LinkURL" class="alert-link">{{toastModel.LinkText}}</a>
    </div>
  </div>
</div>
